import { z } from 'zod';

/**
 * @group Contact
 * 
 * @summary
 * <blockquote>Zod validation schema for contact form submissions</blockquote>
 * 
 * @example
 * ```typescript
 * const result = contactSchema.safeParse({
 *   name: 'John Doe',
 *   email: 'john@example.com',
 *   message: 'Hello world',
 *   formType: 'demo'
 * });
 * ```
 */
export const contactSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().email('Invalid email address'),
  phone: z.string().optional(),
  message: z.string().min(10, 'Message must be at least 10 characters'),
  formType: z.enum(['demo', 'clinician']),
});
